import TeamSettingsTour from './TeamSettingsTour';

export default TeamSettingsTour